import apiClient from '@shared/api'
import { installResponseInterceptor } from '@internal/interceptors/responseInterceptor'
import type { IRouteContext } from '@shared/types/route-context'
import authorization from '@shared/utils/authorization'
import type { CognitoUserSession } from 'amazon-cognito-identity-js'
import { getSavedPath } from '@shared/utils/router-logout-saver'

export const guest = async ({ next }: IRouteContext) => {
  const session: CognitoUserSession | null = await authorization.loadPersisted()
  const customToken = localStorage.getItem('customToken') || null
  const sessionToken: string | null = session ? session.getAccessToken().getJwtToken() : customToken
  installResponseInterceptor({
    apiClient,
  })
  const savedPath = getSavedPath({ user: authorization.user })
  const rootPathSettings =
    session && savedPath
      ? { path: savedPath }
      : {
          path: '/',
        }

  return sessionToken ? next(rootPathSettings) : next()
}
